/** Wrap complete concept groups, never individual aspect-ratio variants. */
export function conceptVariantRows<T>(items: readonly T[], keyOf: (item:T)=>string|number|undefined|null, columns=5) {
  const groups = new Map<string|number|symbol,T[]>();
  items.forEach(item => {
    const key=keyOf(item) ?? Symbol();
    const group=groups.get(key) ?? [];
    group.push(item);groups.set(key,group);
  });
  let row=0;let column=0;
  return Array.from(groups.values()).flatMap(group=>{
    if(column>0 && column+group.length>columns){row++;column=0;}
    const placed=group.map(item=>({item,row,column:column++}));
    if(column>=columns){row++;column=0;}
    return placed;
  });
}
